<template>
  <v-tooltip
    right
    transition='slide-x-transition'
    min-width='100px'
  >
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        class='ma-1 text-white font-weight-medium pa-1 checkIsFirstChip'
        style='height: 24px'
        label
        :color='currentColor'
        v-bind="attrs"
        v-on="on"
      >
        {{item.name | firstCharToUppercase}}
      </v-chip>
    </template>
    <span>{{item.description}} is {{item.value | booleanToText | toUpperCase}}</span>
  </v-tooltip>
</template>

<script>
import { firstCharUppercase } from '@/utils'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentColor() {
      if (this.item.value) return 'rgba(32, 180, 112, 0.85)'
      return 'rgba(189, 49, 56, 0.85)'
    }
  },
  filters: {
    firstCharToUppercase: v => firstCharUppercase(v),
    booleanToText: v => v ? 'available' : 'not available',
    toUpperCase: v => v.toUpperCase()
  }
}
</script>

<style lang='scss'>
  .v-tooltip__content.menuable__content__active {
    background-color: rgba(lighten(#000, 30%), .95);
    opacity: 1 !important;
  }
  .checkIsFirstChip:first-child {
    margin-left: 0 !important;
  }
</style>
